import { useState, useEffect, useRef } from 'react';
import { 
    IonText,
    IonRow,
    IonCol,
    IonGrid,
} from '@ionic/react';
import Fade from 'react-reveal/Fade';

import "./HowSection.css"

// Data for page components
const howArr = [
  {
      'img':'landing/Video1.gif',
      'title':'Input address details for pick-up and drop-off',
  },
  {
      'img':'landing/Video2.gif',
      'title':'Add up to 6 stops in a single trip.',
  },
  {
      'img':'landing/Video3.gif',
      'title':'Select on-demand delivery or advanced trip booking',
  },
  {
      'img':'landing/Video4.gif',
      'title':'Get instant price information',
  },
  {
      'img':'landing/Video5.gif',
      'title':'Track your delivery in real time',
  }
]

const HowWeb = (activeImg, setActiveImg) => {

    useInterval(() => {
        if (activeImg < 4){
            setActiveImg(activeImg + 1);
        } else {
            setActiveImg(0)
        }
      }, 5000);

return(
    <div style={{height:'fit-content'}}>
    <IonGrid>
        <IonRow style={{maxWidth:'1200px', marginInline:'auto'}}>
            <IonCol style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                <Fade up>
                <img src={howArr[activeImg].img} className='phoneImage' />
                </Fade>
            </IonCol>
            <IonCol style={{display:'flex', flexDirection:'column', justifyContent:'center'}}>
                <IonRow>
                    <IonText 
                    className="font-baloo font-m font-semibold"
                    style={{
                        border:'none',
                        color:'#E93864',
                        marginBottom: '20px',
                        lineHeight: '1.5rem',
                        }}>
                        How To Book A Delivery With RydeSEND:
                    </IonText>
                </IonRow>
                {howArr.map((item, index) => {
                    return(
                    <IonRow 
                    style={{
                        backgroundColor: activeImg === index ? '#F9F6F6' : 'transparent',
                        cursor: 'pointer',
                        borderRadius: '20px',
                        paddingInlineStart: '10px',
                    }}
                    // style={{display:'flex', flexDirection:'row', alignItem:'center'}}
                    key={index} onClick={()=>{
                        setActiveImg(index);
                        }}>
                        <IonCol size="2">
                            <div style={{background:'#e93864',width:'fit-content',padding: '0.8rem',borderRadius:'50%', color:'white'}}>0{index+1}</div>
                        </IonCol>
                        <IonCol size="9.2"
                        className="font-baloo font-s"
                        style={{
                            marginLeft:'10px',
                            marginBlock:'auto',
                            fontWeight: activeImg === index ? 'bold' : 'normal',
                            lineHeight: '1rem'
                        }}>
                        {item.title}</IonCol>
                    </IonRow>)
                })}
            </IonCol>
        </IonRow>
    </IonGrid>
    </div>
)
}

const HowMobile = (activeImg, setActiveImg) => {
    useInterval(() => {
        if (activeImg < 4){
            setActiveImg(activeImg + 1);
        } else {
            setActiveImg(0)
        }
      }, 5000);
      
return(
    <div style={{ height:'fit-content', overflow:'hidden'}}>
    <IonGrid style={{height:'fit-content'}}>
        <IonRow>
            <IonCol style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
                <IonText 
                className="font-baloo font-semibold font-s font-pink-1"
                style={{
                border:'none',
                height:'fit-content'
                }}>
                    How To Book A Delivery With RydeSEND:
                </IonText>
            </IonCol>
        </IonRow>
        <IonRow>
            <IonCol style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', maxWidth: '80%', marginInline: 'auto', marginTop:'20px',height:'fit-content'}}>
                <hr 
                style={{
                    height: '2px',
                    width: '100%',
                    background: '#FFFFF',
                    color: '#E93864',
                    borderColor: '#E93864',
                }}
                />
                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    justifyContent:'space-between',
                    width: '100%',
                    transform: 'translateY(-70%)',
                }}>
                {howArr.map((item, index) => {
                    return (
                    <div 
                        key={index}
                        onClick={()=>{setActiveImg(index)}}
                        className="font-baloo"
                        style={{
                        background: activeImg===index? '#e93864' : '#E9E9E9',
                        width:'55px',
                        height:'55px',
                        paddingInline: activeImg===index? '0.8rem': '1rem',
                        paddingBlock: activeImg===index? '0.8rem': '0.8rem',
                        borderRadius:'50%',
                        color: 'white',
                        fontSize:'1.25rem',
                        textAlign: "center",
                        }}>
                        0{index+1}
                    </div>
                    )
                })}
                </div>
            </IonCol>
        </IonRow>
        <IonRow>
            <IonCol 
            style={{
                display:'flex', 
                flexDirection:'column', 
                justifyContent:'center', 
                alignItems:'center', 
                maxWidth: '100%', 
                marginInline: 'auto',
                height:'fit-content'
            }}>
            <IonText 
            className="font-baloo font-s"
            style={{
                transform: 'translateY(-50%)',
                textAlign: 'center',
                height: '30px'
            }}
            >{howArr[activeImg].title}</IonText>
            </IonCol>
        </IonRow>
        <IonRow>
            <IonCol 
            style={{
                display:'flex', 
                flexDirection:'column', 
                justifyContent:'center', 
                alignItems:'center', 
                maxWidth: '100%', 
                marginInline: 'auto',
                height:'fit-content'
            }}>
                <img src={howArr[activeImg].img} className='phoneImage' />
            </IonCol>
        </IonRow>
    </IonGrid>
    </div>
)
}

function useInterval(callback, delay) {
    const savedCallback = useRef();
  
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }

const HowSection = (userDevice) => {
  const [activeImg, setActiveImg] = useState(0);
  return (
    <Fade up>{userDevice==='mobile'? HowMobile(activeImg, setActiveImg):HowWeb(activeImg, setActiveImg)}</Fade>
  )
}

export default HowSection;